import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { ThankYou } from './pages/ThankYou';
import { landingVariants } from './data/landingVariants';
const [bayArea, northernCalifornia, outOfState] = landingVariants;
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3fbj8evsndfrq">
      <Routes data-id="element-1" data-mp="3fb9jzcn93go5">
        <Route path="/bay-area" element={<LandingPage variant={bayArea} data-id="element-3" data-mp="2rkdwgrptv7mp" />} data-id="element-2" data-mp="3f8exlfkofls3" />
        <Route path="/northern-california" element={<LandingPage variant={northernCalifornia} data-id="element-5" data-mp="2mm2mmgzj8x4h" />} data-id="element-4" data-mp="2rlf5yrr73m2b" />
        <Route path="/out-of-state" element={<LandingPage variant={outOfState} data-id="element-7" data-mp="31aqfuglwour9" />} data-id="element-6" data-mp="2mndr6j0sy8wn" />
        <Route path="/thank-you" element={<ThankYou data-id="element-9" data-mp="31ctetq51dy84" />} data-id="element-8" data-mp="31bic7tnbuwil" />
      </Routes>
    </BrowserRouter>;
}